import { render, staticRenderFns } from "./HotlineFloating.vue?vue&type=template&id=08bdf54a&lang=pug&"
import script from "./HotlineFloating.vue?vue&type=script&lang=js&"
export * from "./HotlineFloating.vue?vue&type=script&lang=js&"
import style0 from "./HotlineFloating.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports